<!--
 * @Author: Latte
 * @Date: 2022-01-26 16:02:18
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-26 16:14:53
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\previewResource\index.vue
-->
<template>
  <div class="app-container">
    <el-card>
      <el-tabs v-model="activeIndex" v-tab-change:activeIndex="setActiveName">
        <el-tab-pane label="产品资料" name="productionInfo">
          <ProductionInfo />
        </el-tab-pane>
        <el-tab-pane label="学习园地" name="studyArea">
          <StudyArea />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import ProductionInfo from "./productionInfo.vue";
import StudyArea from "./studyArea.vue";
export default {
  name: "",

  components: { ProductionInfo, StudyArea },

  mixins: [],

  props: {},

  data() {
    return {
      activeIndex:"productionInfo"
    };
  },

  provide() {},

  inject: [],

  watch: {},

  computed: {},

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  activated() {},

  deactivated() {},

  beforeDestroy() {},

  destroyed() {},

  methods: {},
};
</script> 


<style scoped>
</style>
